import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatFormFieldModule } from "@angular/material/form-field";
import { TranslocoModule } from "@jsverse/transloco";
import { LorenKeyValueComponent } from "./loren-key-value/loren-key-value.component";

@NgModule({
  declarations: [],
  exports: [LorenKeyValueComponent],
  imports: [
    CommonModule,
    LorenKeyValueComponent,
    MatFormFieldModule,
    TranslocoModule,
  ],
})
export class LorenKeyValueControlModule {}
